module.exports = __webpack_public_path__ + "static/img/Chun-Hsi Wang.jpg";